/**
 * Type enum to define position of client
 * @typedef PersInfCode
 */
export enum PersInfCode {
	DFLT = 'DFLT', //general info for i-Button
	PERSURL_EVENT = "0001", //all stuart specific info, key is stuart
	BOOKING_EVENT = "0002", //all buart specific info, key is buart
	BOOKING_STUART_EVENT = "0022",
	FALLBACK_EVENT_DIALOG = "0003", // no entryDescription selected
}